// services/userAccessService.js — SharePoint CRUD for SCMUserAccess list
import { getSiteId } from "./sharepointService";

const graphBase = "https://graph.microsoft.com/v1.0";
const USER_ACCESS_LIST = "SCMUserAccess";

function spToUser(fields) {
  return {
    id: fields._spItemId || fields.id || fields.ID,
    email: fields.Title || "",
    name: fields.UserName || "",
    role: fields.Role || "viewer",
    department: fields.Department || "",
    isActive: fields.IsActive !== false,
    grantedBy: fields.GrantedBy || "",
    grantedAt: fields.GrantedAt || new Date().toISOString(),
    notes: fields.Notes || "",
    _spItemId: fields.id || fields.ID,
  };
}

function userToSp(user) {
  return {
    Title: user.email,
    UserName: user.name,
    Role: user.role,
    Department: user.department || "",
    IsActive: user.isActive !== false,
    GrantedBy: user.grantedBy || "",
    GrantedAt: user.grantedAt || new Date().toISOString(),
    Notes: user.notes || "",
  };
}

export async function fetchUserAccessList(token) {
  const siteId = await getSiteId(token);
  const res = await fetch(
    `${graphBase}/sites/${siteId}/lists/${USER_ACCESS_LIST}/items?expand=fields&$top=200`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  if (!res.ok) {
    const errBody = await res.json().catch(() => ({}));
    const err = new Error(errBody.error?.message || `HTTP ${res.status}: Failed to fetch user access list`);
    err.status = res.status;
    throw err;
  }
  return ((await res.json()).value || []).map((i) =>
    spToUser({ ...i.fields, id: i.id }),
  );
}

export async function createUserEntry(token, user) {
  const siteId = await getSiteId(token);
  const res = await fetch(
    `${graphBase}/sites/${siteId}/lists/${USER_ACCESS_LIST}/items`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fields: userToSp(user) }),
    },
  );
  if (!res.ok) {
    const e = await res.json();
    throw new Error(e.error?.message || "Failed to create user entry");
  }
  const item = await res.json();
  return spToUser({ ...item.fields, id: item.id });
}

export async function updateUserEntry(token, spItemId, user) {
  const siteId = await getSiteId(token);
  const res = await fetch(
    `${graphBase}/sites/${siteId}/lists/${USER_ACCESS_LIST}/items/${spItemId}`,
    {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fields: userToSp(user) }),
    },
  );
  if (!res.ok) throw new Error("Failed to update user entry");
}

export async function deleteUserEntry(token, spItemId) {
  const siteId = await getSiteId(token);
  const res = await fetch(
    `${graphBase}/sites/${siteId}/lists/${USER_ACCESS_LIST}/items/${spItemId}`,
    { method: "DELETE", headers: { Authorization: `Bearer ${token}` } },
  );
  if (!res.ok) throw new Error("Failed to delete user entry");
}
